
import { Component, Vue } from "vue-property-decorator";
import Login from "./Login.vue";
import Qrcode from "./Qrcode.vue";

import { getAppLatest } from "@/api/App";

type loginType = "phone" | "password" | "register";

interface Option {
  displayName: string;
  target: string;
  options?: Option[] | null;
  value?: string | null | number;
}
@Component
export default class WHeader extends Vue {
  private active = "首页";
  private scroll = false;

  private visible = false;
  private loginType: loginType = "phone";

  private tabs: Option[] = [
    {
      displayName: "首页",
      target: "/HomePage"
    },
    {
      displayName: "租房",
      target: "/HomePage",
      options: [
        {
          displayName: "全部房源",
          target: "/HomePage"
        },
        {
          displayName: "合租",
          target: "/HomePage"
        },
        {
          displayName: "整租",
          target: "/HomePage"
        },
        {
          displayName: "短租",
          target: "/HomePage"
        },
        {
          displayName: "免押金",
          target: "/HomePage"
        }
      ]
    },
    {
      displayName: "我是业主",
      target: "/HomePage"
    },
    {
      displayName: "关于雷拓尔菲",
      target: "/AboutTy"
    },
    {
      displayName: "房管员",
      target: "/HomePage"
    },
    {
      displayName: "有偿资讯",
      target: "/PaidInfo"
    },
    {
      displayName: "加入我们",
      target: "/HomePage"
    }
  ];

  tabChange(active: Option) {
    this.active = active.displayName;
    this.$router.push(active.target + "?" + Date.now());
  }

  goLogin() {
    this.visible = true;
    this.loginType = "phone";
  }

  goRegister() {
    this.visible = true;
    this.loginType = "register";
  }

  mounted() {
    getAppLatest();
  }

  render() {
    return (
      <div id="header" class="scroll">
        <div class="inner">
          <div class="logo">
            <img src={require("@/assets/logo.png")} />
          </div>
          <div style="display:flex;">
            <div class="tabs">
              {this.tabs.map(tab => (
                <div
                  key={tab.displayName}
                  class={["tab", { active: tab.displayName === this.active }]}
                  onClick={() => this.tabChange(tab)}
                >
                  <a-dropdown placement="bottomCenter" trigger={["hover"]}>
                    <span> {tab.displayName}</span>
                    {tab.options && (
                      <a-menu slot="overlay">
                        {tab.options.map(option => (
                          <a-menu-item key={option.displayName}>
                            <div
                              style="text-align:center;"
                              onClick={() => {
                                this.$router.push(option.target);
                              }}
                            >
                              {option.displayName}
                            </div>
                          </a-menu-item>
                        ))}
                      </a-menu>
                    )}
                  </a-dropdown>
                </div>
              ))}
              <a-popover placement="bottom">
                <template slot="content">
                  <Qrcode></Qrcode>
                </template>
                <div class={["tab"]}>App下载</div>
              </a-popover>
            </div>
            <div class="login-wrap">
              <span onClick={this.goLogin}>登录</span>
              <a-divider type="vertical" />
              <span onClick={this.goRegister}>注册</span>
            </div>
          </div>
        </div>
        <Login
          active={this.loginType}
          visible={this.visible}
          on={{
            "update:visible": (visible: boolean): void => {
              this.visible = visible;
            }
          }}
        ></Login>
      </div>
    );
  }
}
